/**
 * Sets role="presentation" on all table elements within a container.
 * Used to satisfy accessibility scanners treating data tables as layout tables.
 * @param {HTMLElement} rootElement - The container element to search within
 */
export function setTablePresentationRole(rootElement) {
  if (!rootElement) return;
  rootElement.querySelectorAll('table').forEach((table) => {
    table.setAttribute('role', 'presentation');
  });
}
